import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const InfoSection = ({
  editEnable,
  placeholder,
  label,
  name,
  value,
  error,
  onChange,
}) => (
  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
    <div className="form-group">
      <strong className="col-xs-6 control-label">{label}</strong>
      <div className="col-xs-6 texto-gris">
        {editEnable ? (
          <>
            <input
              type="password"
              className="form-control"
              onChange={onChange}
              name={name}
              value={value}
              error={error}
              placeholder={placeholder}
            />
            {error && (
              <>
                <span className="input-group-addon error-icon">
                  <i className="fa fa-exclamation-triangle" />
                </span>
                <span className="help-block error-wrapper error-invalid">
                  {error}
                </span>
              </>
            )}
          </>
        ) : (
          <p className="form-control-static">{value}</p>
        )}
      </div>
    </div>
  </div>
);

InfoSection.propTypes = {
  editEnable: PropTypes.bool,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
};

export default InfoSection;
